// importer la librairie de react
import React, { useEffect, useState } from "react"
import { Box } from "@mui/material"
import { PageConfig, CwComponentConfig } from "../../models/pageConfig"
import ActionService from "../../services/action"
import DialogService from "../../services/dialog"
import { DialogType } from "../../models/dialog"
import ComponentService from "@front-apps/core/services/component"
import ComponentsUtils from "@front-apps/core/utils/components"

const CwBox = (
    props: PageConfig<CwComponentConfig.Box>
): React.JSX.Element | null => {
    const { config } = props
    // création de toute les variables à partir des config
    const {
        alignItems,
        display,
        flexDirection,
        justifyContent,
        context,
        useRefreshListener,
        useConfigListener,
        edit,
        formLink,
    } = config
    // crée la liste des composants présent dans la card et son setter
    const [components, setComponents] = useState<Array<React.JSX.Element>>([])
    const className = config.className || ""
    const [hidden, setHidden] = useState<boolean>(config.hidden || false)
    /**
     * Fonction d'exec des actions d'initialisation
     */
    const init = () => {
        const boxChilds = []
        /* initialisation des composants fils */
        if (formLink) {
            if (props.fields) {
                for (let i = 0; i < props.fields.length; i++) {
                    const element = props.fields[i]

                    element.config.edit = props.config.edit || false
                    const createdComponent =
                        ComponentService.getInstance().create(element)
                    boxChilds.push(createdComponent)
                }
                setComponents(boxChilds)
            }
        } else {
            if (props.fields) {
                ComponentsUtils.initChildFieldsComponent(
                    props.fields,
                    setComponents
                )
            }
        }
        if (props.actions && props.actions.length)
            ActionService.exec(props.actions, context).then((conf) => {
                // override des attrs de state par ceux de conf
                if (conf?.type === "config") setHidden(conf.value.hidden)
            })
    }

    useEffect(() => {
        init()
    }, [edit])
    useEffect(() => {
        let subId: string | null = null
        // on s'abonne aux changements de route
        if (useRefreshListener)
            subId = DialogService.getInstance().subscribe(
                "pageRefesh",
                DialogType.REFRESH,
                props.name,
                () => {
                    init()
                }
            )

        // unsubscribe
        return () => {
            if (subId) DialogService.getInstance().unsubscribe(subId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        let subId: string | null = null
        // abonnement aux changments de config (hide / show)
        if (useConfigListener)
            subId = DialogService.getInstance().subscribe(
                "all",
                DialogType.CONFIG,
                props.name,
                (param: any) => {
                    setHidden(param.hidden)
                }
            )

        // unsubscribe
        return () => {
            if (subId) DialogService.getInstance().unsubscribe(subId)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return !hidden ? (
        <Box
            className={className}
            alignItems={alignItems}
            display={display}
            flexDirection={flexDirection}
            justifyContent={justifyContent}
        >
            {components}
        </Box>
    ) : null
}
export default CwBox
